import { useQuery } from '@tanstack/react-query';
import { edgeFetch, createAuthHeaders } from '../lib/cpClient';
import { FEATURES } from '../lib/features';
import { useAuthStore } from '../store/authStore';

export default function FreezeBanner(){
  const { token, selectedTenant } = useAuthStore();
  const headers = token ? createAuthHeaders(token, selectedTenant || 'dev') : {} as any;
  const { data } = useQuery({
    queryKey: ['freeze','status','banner', selectedTenant],
    queryFn: async () => {
      if (!FEATURES.freezeStatus) {
        return { enabled: false, windows: [] };
      }
      const res = await edgeFetch('/cp/freeze/status', { headers });
      if (res.status === 404) {
        // Endpoint not implemented → treat as no freeze, avoid noisy errors
        return { enabled: false, windows: [] } as any;
      }
      if (!res.ok) {
        // Non-OK but not 404 → fail once, but do not retry aggressively
        throw new Error(`freeze ${res.status}`);
      }
      return res.json();
    },
    // Reduce noise: no retries and slower polling
    retry: false,
    refetchInterval: 60000,
    enabled: FEATURES.freezeStatus && !!token,
  });
  if (!FEATURES.freezeStatus) return null;
  if (!data?.enabled || (data?.windows||[]).length===0) return null;
  return (
    <div className="w-full bg-amber-600 text-white text-sm px-4 py-2">
      Change Freeze active: operations may be blocked. Check <a className="underline" href="/freeze">Freeze</a>.
    </div>
  );
}




